import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PortalHttpActivityService } from './portal-http-activity.service';

@Injectable()
export class PortalHttpActivityInterceptor implements HttpInterceptor {
  constructor(private activity: PortalHttpActivityService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const id = this.activity.begin(req);
    if (id == null) {
      return next.handle(req);
    }
    return next.handle(req).pipe(finalize(() => this.activity.end(id)));
  }
}
